import React, { useState } from "react";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import Icon from "../assets/Icon.png";
import { FaInstagram, FaLinkedin } from "react-icons/fa"; // social icons
import { FaFacebook } from "react-icons/fa6";
import { MdOutlinePhoneInTalk } from "react-icons/md";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isCompanyOpen, setIsCompanyOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setIsServicesOpen(false);
    setIsCompanyOpen(false);
  };

  const toggleServices = () => {
    setIsServicesOpen(!isServicesOpen);
  };

  const toggleCompany = () => {
    setIsCompanyOpen(!isCompanyOpen);
  };

  return (
    <>
      {/* Background Behind Navbar */}
      <div className="bg-[#d2e5e4] w-full h-32 md:h-30 relative z-0" />

      {/* Floating Navbar */}
      <header className="w-full flex justify-center absolute top-12 md:top-8 left-1/2 transform -translate-x-1/2 z-50">
        <div className="w-[90%] md:max-w-[80%] bg-white rounded-xl shadow-md px-4 py-2 flex items-center justify-between">
          {/* Logo */}
          <Link
            to="/"
            className="text-[#3d302c] tracking-wide leading-tight inline-block"
          >
            <div className="flex items-center gap-2">
              <img src={Icon} alt="Medimind Icon" className="w-6 h-6" />
              <div>
                <div className="text-xl font-bold leading-tight">Medimind</div>
                <div className="text-xs -mt-1 font-bold">AI Solutions</div>
              </div>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex gap-6 items-center relative">
            <Link
              to="/"
              className="text-[#3d302c] hover:underline font-semibold"
            >
              Home
            </Link>

            <div className="relative group">
              <button className="text-[#3d302c] hover:underline focus:outline-none font-semibold">
                Company ▾
              </button>
              <div className="absolute left-0 mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-lg opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transform transition duration-200 ease-in-out z-50">
                <Link
                  to="/about"
                  className="block px-4 py-2 text-[#3d302c] hover:bg-[#f9f9f9] font-semibold"
                >
                  About Us
                </Link>
                <Link
                  to="/blog"
                  className="block px-4 py-2 text-[#3d302c] hover:bg-[#f9f9f9] font-semibold"
                >
                  Blog
                </Link>
                <Link
                  to="/brouchers"
                  className="block px-4 py-2 text-[#3d302c] hover:bg-[#f9f9f9] font-semibold"
                >
                  Brouchers
                </Link>
              </div>
            </div>

            <div className="relative group">
              <button className="text-[#3d302c] hover:underline focus:outline-none font-semibold">
                Products ▾
              </button>
              <div className="absolute left-0 mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-lg opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transform transition duration-200 ease-in-out z-50">
                <Link
                  to="/medops"
                  className="block px-4 py-2 text-[#3d302c] hover:bg-[#f9f9f9] font-semibold"
                >
                  MedOps
                </Link>
                <Link
                  to="/pharmaconnect"
                  className="block px-4 py-2 text-[#3d302c] hover:bg-[#f9f9f9] font-semibold"
                >
                  PharmaConnect
                </Link>
                <Link
                  to="/apiintegrationssection"
                  className="block px-4 py-2 text-[#3d302c] hover:bg-[#f9f9f9] font-semibold"
                >
                  API Integrations
                </Link>
              </div>
            </div>

            <Link
              to="/contact"
              className="text-[#3d302c] hover:underline font-semibold"
            >
              Contact us
            </Link>

            {/* Buttons */}
            <a
              href="https://abha.abdm.gov.in/abha/v3/register"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#00BFFF",
                  color: "#3d302c",
                  fontWeight: "bold",
                  padding: "6px 16px",
                  borderRadius: "8px",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#dba832",
                  },
                }}
              >
                Create ABHA No
              </Button>
            </a>

            <Link to="/scheduleform">
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#f0b83d",
                  color: "#3d302c",
                  fontWeight: "bold",
                  padding: "6px 16px",
                  borderRadius: "8px",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#dba832",
                  },
                }}
              >
                Request a Demo
              </Button>
            </Link>
          </nav>

          {/* Mobile toggle button */}
          <button
            className="md:hidden text-sm text-[#3d302c] border px-3 py-1 rounded hover:bg-gray-100"
            onClick={toggleMobileMenu}
          >
            {isMobileMenuOpen ? "✖" : "☰"}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden w-[90%] bg-white mt-2 px-6 py-4 rounded-xl shadow-md absolute top-[100%] left-1/2 transform -translate-x-1/2 z-40">
            <div className="flex flex-col gap-4 text-[#3d302c]">
              <Link
                to="/"
                className="hover:underline"
                onClick={toggleMobileMenu}
              >
                Home
              </Link>

              <div>
                <button
                  onClick={toggleCompany}
                  className="hover:underline focus:outline-none flex justify-between w-full"
                >
                  Company ▾
                </button>
                {isCompanyOpen && (
                  <div className="mt-2 ml-4 flex flex-col gap-2">
                    <Link
                      to="/about"
                      className="hover:underline"
                      onClick={toggleMobileMenu}
                    >
                      About Us
                    </Link>
                    <Link
                      to="/blog"
                      className="hover:underline"
                      onClick={toggleMobileMenu}
                    >
                      Blog
                    </Link>
                    <Link
                      to="/brouchers"
                      className="hover:underline"
                      onClick={toggleMobileMenu}
                    >
                      Brouchers
                    </Link>
                  </div>
                )}
              </div>

              <div>
                <button
                  onClick={toggleServices}
                  className="hover:underline focus:outline-none flex justify-between w-full"
                >
                  Products ▾
                </button>
                {isServicesOpen && (
                  <div className="mt-2 ml-4 flex flex-col gap-2">
                    <Link
                      to="/medops"
                      className="hover:underline"
                      onClick={toggleMobileMenu}
                    >
                      MedOps
                    </Link>
                    <Link
                      to="/pharmaconnect"
                      className="hover:underline"
                      onClick={toggleMobileMenu}
                    >
                      PharmaConnect
                    </Link>
                    <Link
                      to="/apiintegrationssection"
                      className="hover:underline"
                      onClick={toggleMobileMenu}
                    >
                      API Integrations
                    </Link>
                  </div>
                )}
              </div>

              <Link
                to="/contact"
                className="hover:underline"
                onClick={toggleMobileMenu}
              >
                Contact us
              </Link>

              {/* Buttons */}
              <a
                href="https://abha.abdm.gov.in/abha/v3/register"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full"
              >
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#00BFFF",
                    color: "#3d302c",
                    fontWeight: "bold",
                    padding: "6px 16px",
                    borderRadius: "8px",
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#009acd",
                    },
                  }}
                >
                  CREATE ABHA NO
                </Button>
              </a>

              <Link to="/scheduleform">
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#f0b83d",
                    color: "#3d302c",
                    fontWeight: "bold",
                    padding: "6px 16px",
                    borderRadius: "8px",
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#dba832",
                    },
                  }}
                >
                  Request a Demo
                </Button>
              </Link>
            </div>
          </div>
        )}

        <div className="flex flex-col items-center space-y-2 text-[#1e2761] ms-3">
          <a
            href="tel:+919888268456"
            className="flex items-center gap-2 text-md font-medium hover:text-blue-600"
          >
            <MdOutlinePhoneInTalk className="w-5 h-5" />
            <span>+91 9888268456</span>
          </a>

          <div className="flex space-x-5 text-1xl">
            <a
              href="https://www.linkedin.com/company/medimind-ai-solutions/posts/?feedView=all"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-600"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.facebook.com/share/16GWVKNAiV/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-600"
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/medimindaisolutions?igsh=eGtlYm5sMjVhMTcy"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-600"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </header>
    </>
  );
};

export default Navbar;
